import type { QueryClient } from "@tanstack/react-query";

/**
 * Keys to re-seed with null after clear so session/user don't refetch (avoids post-logout race).
 */
export type AuthCacheKeys = {
  sessionCheckKey: readonly string[];
  userKey: readonly string[];
};

/**
 * Clear all React Query cache. Call on logout so the next user never sees previous user data.
 * If authKeys is provided, re-seeds session and user with null so useSessionCheck/useUser
 * don't refetch (prevents GET /auth/session from racing and redirecting back to a protected route).
 */
export function clearCacheOnLogout(
  queryClient: QueryClient,
  authKeys?: AuthCacheKeys
): void {
  queryClient.clear();
  if (authKeys) {
    queryClient.setQueryData(authKeys.sessionCheckKey, null);
    queryClient.setQueryData(authKeys.userKey, null);
  }
}
